import { render } from "./DownloadApplication.vue?vue&type=template&id=132cc2b9&scoped=true"
import script from "./DownloadApplication.vue?vue&type=script&lang=js"
export * from "./DownloadApplication.vue?vue&type=script&lang=js"

import "./DownloadApplication.vue?vue&type=style&index=0&id=132cc2b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132cc2b9"]])

export default __exports__